module.exports = __webpack_public_path__ + "static/media/TheRaceRowStar.13eec9e5.svg";